import { Component, OnDestroy, OnInit } from '@angular/core';
import { ImmigrationWizardService } from '../services/immigration-wizard.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { UpdateWizardComponent } from '../update-wizard/update-wizard.component';
import { SwithModePopupComponent } from '../switch-mode-popup/switch-mode-popup.component';
import * as RolesRouteMap from 'app-models';

@Component({
  selector: 'app-immigration-wizard-container.component',
  templateUrl: './immigration-wizard-container.component.html',
  styleUrls: ['./immigration-wizard-container.component.scss']
})
export class ImmigrationWizardContainerComponent implements OnInit,OnDestroy { 
  menuListItems: any;
  userType;
  uploadTypes: any = [];
  observableSubscription$ = new Subject();
  superTaskId: any;
  leftPanelCollapsed: boolean = false;

  constructor(public immigrationWizardService: ImmigrationWizardService, private route: ActivatedRoute, private dialogService: DialogService, private router: Router,) { }

  ngOnInit(): void {
    this.onLoadPage();
    this.userType = sessionStorage.getItem('userTypeRole');
  }

  onLoadPage(updateHeaderData: boolean = true){
    if(sessionStorage.getItem('wizardTID')){
      this.immigrationWizardService.getTaskDetails(sessionStorage.getItem('wizardTID')).pipe(takeUntil(this.observableSubscription$)).subscribe((res: any)=>{
        if(res){
          this.loadWizardSettings(res?.superTaskId);
          sessionStorage.setItem('wizardTIDbeneficiaryId', res?.beneficiaryId);
          sessionStorage.setItem('beneficiaryId', res?.beneficiaryId);
          sessionStorage.setItem('tempPetitionId', res?.petitionId);
          this.immigrationWizardService.setWizardTaskDetails$(res);
          if(updateHeaderData){
            this.immigrationWizardService.setWizardTaskHeaderDetails$(res);
          }
        }
      }); 
    }
  }

  loadWizardSettings(superTaskId){
    this.uploadTypes = [
      {
        title: 'Individual Details',
        description: ['Personal', 'Education', 'Experience', 'Immigration'],
        isChecked: false,
        linkLabel: 'INDIVIDUAL DETAILS',
        route: '../upload/individual-details',
        id: 'individual-details'
      },
      {
        title: 'SOC CODE AND LCA',
        description: ['SOC Code and LCA', 'Link LCA to petition'],
        isChecked: false,
        linkLabel: 'SOC CODE AND LCA',
        route: '../upload/soc-code',
        id: 'soc-code'
      },
      {
        title: 'Job Description',
        description: ['Job Description'],
        isChecked: false,
        linkLabel: 'JOB DESCRIPTION',
        route: '../upload/job-descrtiption',
        id: 'job-descrtiption'
      },
      {
        title: 'USCIS Content',
        description: ['USCIS Content'],
        isChecked: false,
        linkLabel: 'USCIS CONTENT',
        route: '../upload/uscis-content',
        id: 'uscis-content'
      },
      {
        title: 'Generate Letters',
        description: ['Document Upload'],
        isChecked: false,
        linkLabel: 'GENERATE FORMS & LETTERS',
        route: '../upload/generate-letters',
        id: 'generate-letters'
      },
      {
        title: 'ANALYSE / REVIEW',
        description: ['ANALYSE/ REVIEW'],
        isChecked: false,
        linkLabel: 'ANALYSE/ REVIEW',
        route: '../upload/analyse-review',
        id: 'analyse-review'
      },
      {
        title: 'SEND FOR SIGNATURE & GENERATE FINAL',
        description: ['Send for signature'],
        isChecked: false,
        linkLabel: 'SEND FOR SIGNATURE & GENERATE FINAL',
        route: '../upload/send-forms-signature',
        id: 'send-for-signature'
      }, 
      {
        title: 'SUBMIT PETITION & UPDATE RECEIPT',
        description: ['SUBMIT PETITION & UPDATE RECEIPT'],
        isChecked: false,
        linkLabel: 'SUBMIT PETITION & UPDATE RECEIPT',
        route: '../upload/submit-petition',
        id: 'submit-petition'
      }
    ];
    this.immigrationWizardService.getWizardSettings(superTaskId).pipe(takeUntil(this.observableSubscription$)).subscribe((res: any)=> {
      if(res){
        this.menuListItems = res;
        this.immigrationWizardService.setWizardSettingsDetails$(this.menuListItems);
        Object.keys(this.menuListItems).forEach(key=> {
          const val = this.menuListItems[key];
          switch(key) {
              case 'eerDetails': 
                    if(val==1){
                      this.uploadTypes.push(
                        {
                          title: 'Employer Employee Relationship',
                          description: ['Document Upload'],
                          isChecked: false,
                          linkLabel: 'EMPLOYER EMPLOYEE RELATIONSHIP',
                          route: '../upload/employer-employee-relationship',
                          id: 'employer-employee-relationship'
                        }
                      );
                    }
                    break;
              case 'ios': 
                    if(val==1){
                      this.uploadTypes.push({
                        title: 'Itinerary of Services',
                        description: ['Itinerary of Services'],
                        isChecked: false,
                        linkLabel: 'ITINERARY OF SERVICES',
                        route: '../upload/itinerary-of-services',
                        id: 'itinerary-of-services'
                      });
                    }
                    break;
              case 'qualification': 
                    if(val==1){
                      this.uploadTypes.push(
                        {
                          title: 'Beneficiary Education Details',
                          description: ['Document Upload'],
                          isChecked: false,
                          linkLabel: 'BENEFICIARY EDUCATION DETAILS',
                          route: '../upload/education-details',
                          id: 'education-details'
                        }
                      );
                    }
                    break;
              case 'default':
                    break;
          }
        });
        let requiredTitles = ["Beneficiary Education Details", "Itinerary of Services", "Employer Employee Relationship"];
        let requiredItems = this.uploadTypes.filter(item => requiredTitles.includes(item.title));
        let otherItems = this.uploadTypes.filter(item => !requiredTitles.includes(item.title));
        let newArray = [
          ...otherItems.slice(0, 3),
          ...requiredItems,
          ...otherItems.slice(3)
        ];
        this.uploadTypes = newArray;
        this.immigrationWizardService.selectedUploadTypes.next(this.uploadTypes);
        this.router.navigate([`${RolesRouteMap.userRoleRouteMapping[localStorage.getItem('userTypeRole')]}/immigration-wizard/upload/${this.uploadTypes[0]?.id}`]);
      }
    });
  }

  updateWizard() {
    const dialogConfig = {
      width: '60%',
      closeOnEscape: false,
      closable: false,
      showHeader: false,
      contentStyle: { "z-index": "1001" }
    };
    const wizardRef = this.dialogService.open(UpdateWizardComponent, {
      ...dialogConfig,
    });
    wizardRef.onClose
    .pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
      if (response) {
        this.ngOnInit();
      }
    })
  }


  onClickSettings(){
    const dialogSettingsConfig = {
      width: '60%',
      closeOnEscape: false,
      closable: false,
      showHeader: false,
      contentStyle: { "z-index": "1001" },
      styleClass: 'wizardSettings',
    };  
    const wizardRef = this.dialogService.open(SwithModePopupComponent, {
      ...dialogSettingsConfig,
    });
    wizardRef.onClose
    .pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
      if (response) {
        let updateHeader = true;
        if(response?.data?.individualDetailsType === 'REQTINDIVIDUALDOC'){
          this.immigrationWizardService.setWizardReqDataDocsDetails$(true);
          updateHeader = false;
        }
        this.onLoadPage(updateHeader);
      }
    })
  }

  ngOnDestroy(){
    sessionStorage.removeItem('wizardTID');
    sessionStorage.removeItem('tempPetitionId');
  }

}
